import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';

import { SlimscrollDirective } from './slimscroll.directive';
import { PreloaderComponent } from './preloader/preloader.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import {RouterModule} from "@angular/router";

@NgModule({
  declarations: [SlimscrollDirective, PreloaderComponent, PagetitleComponent],
    imports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        NgbCollapseModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        RouterModule
    ],
  exports: [SlimscrollDirective, PreloaderComponent, PagetitleComponent]
})
export class UIModule { }
